import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const GenderFilter = ({ handleGenderChange, checkGender, genderFilter }) => {
  const selectedValues = checkGender.map(item => item.value);
  return (
    <FilterCheckBoxComp
      options={genderFilter}
      value={selectedValues}
      onChange={handleGenderChange}
      valueParam="value"
      labelParam="label"
    />
  )
}

export default GenderFilter
